import crypto from "crypto-js";
import { useContext, useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { useParams } from "react-router-dom";
import Select from "react-select";
import TextareaAutosize from "react-textarea-autosize";
import Chartcontext from "../../Context/Chartcontext";
import { doesChartNoExistInSystem } from "../../services/chartService";
import {
  chartStatusConstants,
  milestoneConstants,
  qcStatusConstants,
  userRole,
} from "../../utils/constants";
import AuthContext from "../Auth/Middleware/AuthContext";
import "./ChartForm.css";
import AllocationConfirmationModal from "./AllocationConfirmationModal";
import configurationAPI from "../../apis/configuration/configurationAPI";

const moment = require("moment");

function ChartInfo({
  configureField,
  masterData,
  getmr_no,
  enabled,
  getdata,
  data,
  clientData,
  handleDateTimeChange,
  errorsForChat,
  handleKeypress,
  handleKeypressMR,
  errorsFromAuditorToChart,
  setIsTouched,
  btnDisable,
  chartInfoCustomFieldOnChangeData,
  setChartInfoCustomFieldOnChangeData,
  customFieldsError,
  setCustomFieldIdsForValidation,
  setSpecialCharCustomFieldIds
}) {
  const {
    defaultAudit,
    defaultHold,
    defaultResponsible,
    defaultChartStatus,
    setDefaultAudit,
    setDefaultHold,
    setDefaultResponsible,
    setDefaultChartStatus,
    setDefaultPrimaryHealth,
    setDefaultFacility,
    setDefaultDisposition,
    setDefaultSubSpecialty,
    chartstatus,
    allocateAuditor,
    allocateEDCoder,
    setAllocateAuditor,
    setAllocateEDCoder,
    setInputval,
    setDefaultQC,
    defaultQC,
    inpval,
    priority,
    setPriority,
    isQc,
  } = useContext(Chartcontext);
  const [statusId, setStatusId] = useState();
  const { role } = useContext(AuthContext);
  const [none, setNone] = useState();
  const [noneForDisplay] = useState({
    label: "None",
    value: 4,
  });
  const [noneDefault, setNoneDefault] = useState();
  const [noReasons, setNoReasons] = useState();
  
  const auth = useContext(AuthContext);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [coderAllocationEvent, setCoderAllocationEvent] = useState({});
  const [chartNumberExists, setChartNumberExists] = useState(false);
  const [chartInfoCustomFields, setChartInfoCustomFields] = useState([]);

  let strRegex = new RegExp(/^[a-z0-9]+$/i);
  let strRegexPirmaryDiagnosis = new RegExp(/^[a-z0-9.]+$/i);
  // eslint-disable-next-line no-useless-escape
  let strRegexForEmModifierProcCode = new RegExp(/^[a-zA-Z0-9\.,_\-!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]+$/i);

  let dosOP = {
    dateFormat: "m/d/Y",
    minDate: data?.ReceivedDate,
    maxDate: new Date(),
  };
  const { id } = useParams();
  const [isUserAllowedToSelectPriority, setFlagToAllowUserToSelectPriority] =
    useState(false);

  // useEffect(() => {
  //   fetchRecords(id);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [enabled]);

  // const fetchRecords = (id) => {
  //   getChartAuditInfo(id).then((data) => {
  //     setIsQc(data?.data?.QCStatusId ?? null);
  //     setDefaultQC(data?.data?.QCStatus ?? null);
  //   });
  // };
  const fetchChartInfoCustomFields = async() => {
    try {
      const res = await configurationAPI.getChartInfoCustomFields(clientData.ClientId, clientData.LocationId);
      if (res.success) {
        setChartInfoCustomFields(res?.data);
        setCustomFieldIdsForValidation(res?.data?.filter(item => (item?.validation === "Mandatory")).map((item) => item.id));
        setSpecialCharCustomFieldIds(res?.data?.filter(item => item?.isSpecialCharAllowed).map((item) => item.id));
      } else {
        window.toastr.error(res?.message)
      }
    } catch (error) {
      window.toastr.error(error?.message || "Couldn't fetch chart info custom fields.");
    }
  };
  
  useEffect(() => {
    let flag = true;
    if (flag && clientData.ClientId && clientData.LocationId) {
      fetchChartInfoCustomFields()
    }
    return () => flag = false;

    // eslint-disable-next-line
  }, [clientData.ClientId, clientData.LocationId]);
  
  useEffect(() => {
    if (clientData?.customFieldValues?.length > 0) {
      const data = clientData?.customFieldValues && (clientData.customFieldValues).reduce((acc, item) => {
        if (item?.ChartInfoCustomField?.type === 'dropdown') {
          acc[item.ChartInfoCustomFieldId] = item.ChartInfoDropdowns ? item.ChartInfoCustomField?.isMultiSelect ? item.ChartInfoDropdowns?.map((dropdown) => ({ value: dropdown?.id, label: dropdown?.name })) : { value: item?.ChartInfoDropdowns[0]?.id, label: item?.ChartInfoDropdowns[0]?.name } : null;
        } else {
          acc[item.ChartInfoCustomFieldId] = item.value;
        }
        return acc;
      }, {});
      setChartInfoCustomFieldOnChangeData(data);
    }

    // eslint-disable-next-line
  }, [clientData]);

  const handleChartInfoCustomFieldDataChange = (fieldId, value) => {
    setChartInfoCustomFieldOnChangeData((prev) => ({ ...prev, [fieldId]: value }));
  }
  const renderChartInfoCustomField = (field) => {
    const type = field.type;
    if (type === 'text' || type === 'number') {
      return (<input
        type={(type === 'number' && field.isSpecialCharAllowed) ? 'text' : type}
        className="form-control"
        value={chartInfoCustomFieldOnChangeData[field.id] ?? ''}
        onChange={(e) => {
          const value = e.target.value;

          // Only for number fields with special char enabled
          if (type === 'number' && field.isSpecialCharAllowed) {
            const regex = /^[0-9\.,_\-!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]*$/;

            if (!regex.test(value)) {
              return; 
            }
          }

          handleChartInfoCustomFieldDataChange(field.id, value);
        }}
        disabled={
          btnDisable || (data?.MilestoneId !== milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID)
        }
      />);
    } else if (type === 'date') {
      return (<Flatpickr
        className="form-control"
        placeholder="Select a Date"
        options={{
          dateFormat: "m/d/Y",
        }}
        value={chartInfoCustomFieldOnChangeData[field.id]}
        onChange={(_,date) => handleChartInfoCustomFieldDataChange(field.id, date)}
        disabled={
          btnDisable ||
          (data?.MilestoneId !== milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID)
        }
      />)
    } else if (type === 'dropdown') {
      let renderOptions = () => field.ChartInfoDropdowns?.map(option => ({
        label: option?.name,
        value: option?.id
      }));
      return (<Select
        options={renderOptions()}
        isMulti={field?.isMultiSelect || false}
        value={chartInfoCustomFieldOnChangeData[field.id]}
        onChange={(e) => handleChartInfoCustomFieldDataChange(field.id, e)}
        isDisabled={
          btnDisable || (data?.MilestoneId !== milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID)
        }
      />)
    }
  }

  useEffect(() => {
    setDefaultAudit(data.AuditOptions);
    setDefaultChartStatus({
      label: data.Status,
      value: data.StatusId,
    });

    setDefaultResponsible(data.ResponsibleParties);

    setDefaultHold(data.HoldReasons);

    setDefaultDisposition({
      label: data.Disposition,
      value: data.DispositionId,
    });
    setDefaultSubSpecialty({
      label: data.SubSpecialty,
      value: data.SubSpecialtyId,
    });
    const hasValue19 = data?.HoldReasons?.some((item) => item.value === 28);
    setNoReasons(hasValue19);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.audit, data.Status]);

  const renderList = () => {
    return data.audit?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderQC = () => {
    return masterData?.qc_status
      ?.filter(
        (data) =>
          data.id === qcStatusConstants.QC_IMPLEMENTED_ID ||
          data.id === qcStatusConstants.QC_REJECTED_ID,
      )
      .map((data) => ({
        label: data.name,
        value: data.id,
      }));
  };
  const handledefaultQC = (event) => {
    if (auth.role === "Coder") {
      if (event.value === 3) {
        setAllocateAuditor("");
      }
    }
    setDefaultQC(event);
  };

  const renderResponsibleList = () => {
    return data.responsible?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderHoldList = () => {
    return data.holdreason?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderChartStatusList = () => {
    return chartstatus?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderAllocateAuditor = () => {
    return masterData?.auditors_active?.map((data) => ({
      label: `${data.name}`,
      value: data.id,
    }));
  };

  const renderActiveCoder = () => {
    return masterData?.coders_active?.map((data) => ({
      label: `${data.name}`,
      value: data.id,
    }));
  };

  const renderSubSpecialties = () => {
    return masterData?.subSpecialties?.map((data) => ({
      label: `${data.name}`,
      value: data.id,
    }));
  };

  const renderPrimaryHealth = () => {
    return masterData?.primary_health?.map((data) => ({
      label: `${data.name}`,
      value: data.id,
    }));
  };

  const renderFacility = () => {
    return masterData?.facility?.map((data) => ({
      label: `${data.name}`,
      value: data.id,
    }));
  };

  const renderDispositionList = () => {
    return data.get?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderPriorityList = () => {
    return masterData?.priorities?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const handlePriorityChange = (event) => {
    setPriority(event);
  };

  const handleAuditChange = (event) => {
    const containsValue4 = event.some((item) => item.value === 4);
    setNone(containsValue4);
    if (containsValue4 === false) {
      setDefaultAudit(event);
    } else {
      setDefaultAudit([{ value: 4, label: "None" }]);
    }
  };

  const handleHoldChange = (event) => {
    const hasValue19 = event.some((item) => item.value === 28);
    setNoReasons(hasValue19);
    if (hasValue19 === true) {
    }
    if (statusId !== chartStatusConstants.INCOMPLETE_STATUS_ID) {
      data.CoderComments = "";
    }
    if (
      defaultChartStatus.value === chartStatusConstants.INCOMPLETE_STATUS_ID &&
      hasValue19 === false
    ) {
      setDefaultHold(event);
    } else {
      setDefaultHold([{ label: "No Reason", value: 28 }]);
    }
  };

  const handleRespChange = (event) => {
    setDefaultResponsible(event);
  };

  const handleChartChange = (event) => {
    setStatusId(event.value);
    setDefaultChartStatus(event);
    if (event.value !== 3) {
      setDefaultHold([]);
    }
    if (event.value !== 2) {
      data.DateOfCompletion = "";
      setInputval(() => {
        return {
          ...inpval,
          date_of_completion: null,
        };
      });
    } else {
    }
  };

  const handleDispositionChange = (event) => {
    setDefaultDisposition(event);
  };

  const handleSubSpecialtyChange = (event) => {
    setDefaultSubSpecialty(event);
    setFlagToAllowUserToSelectPriority(true);
  };

  const handleFacilityChange = (event) => {
    setDefaultFacility({
      label: event.label,
      value: event.value,
    });
  };

  const handlePrimaryHealthChange = (event) => {
    setDefaultPrimaryHealth(event);
  };

  const handleAllocateAuditor = (event) => {
    if (event.label !== " ") {
      setAllocateAuditor(event);
    } else {
      setAllocateAuditor({ lable: "", value: "" });
    }
  };

  const handleAllocatEDCoder = (event) => {
    if (data.ReceivedDate === moment().format("MM/DD/YYYY")) {
      setShowConfirmationModal(true);
      setCoderAllocationEvent({
        label: event.label,
        value: event.value,
      });
    } else {
      if (event.label !== " ") {
        setAllocateEDCoder({
          label: event.label,
          value: event.value,
        });
      } else {
        setAllocateEDCoder({ label: "", value: "" });
      }
    }
  };

  useEffect(() => {
    if (none === undefined || none === false) {
      const containsDefaultValue4 = defaultAudit?.some(
        (item) => item.value === 4,
      );
      setNoneDefault(containsDefaultValue4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultHold, defaultResponsible, noneDefault, defaultAudit]);

  // useEffect(() => {
  //   setIsTouched(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [Flatpickr, allocateAuditor]);

  useEffect(() => {
    const isIpOrObsSpecialityChart = clientData?.Specialty
      ? clientData.Specialty.toLowerCase() === "inpatient" ||
        clientData.Specialty.toLowerCase() === "observation"
      : false;

    if (isIpOrObsSpecialityChart) {
      setFlagToAllowUserToSelectPriority(true);
    }
  }, [clientData]);

  useEffect(() => {
    setTimeout(() => {
      if (document.querySelector(".flatpickr-monthDropdown-months")) {
        document.querySelector(
          ".flatpickr-monthDropdown-months",
        ).lastElementChild.selected = true;
        document
          .querySelector(".flatpickr-monthDropdown-months")
          .dispatchEvent(new Event("change"));
      }
      setDefaultChartStatus({
        label: data.Status,
        value: data.StatusId,
      });
      setDefaultQC({
        label: data?.qc_status,
        value: data.qc_status_id,
      });
      setDefaultHold(data.HoldReasons);
      setDefaultAudit(data.AuditOptions);
    }, 2000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const qcValue = [
    qcStatusConstants.QC_IMPLEMENTED_ID,
    qcStatusConstants.QC_REJECTED_ID,
  ].includes(defaultQC?.value)
    ? defaultQC
    : null;

  let earliestDOS = data.DateOfService ?? null;
  let latestDOS = data.DateOfService ?? moment().format("MM/DD/YYYY");

  if (data.ChartDosRange) {
    [earliestDOS, latestDOS] = data.ChartDosRange.split(" - ");
  }

  if (earliestDOS && latestDOS) {
    earliestDOS = new Date(earliestDOS.trim());
    latestDOS = new Date(latestDOS.trim());
  }

  const isPropertyRequired = (property) => {

    const fieldRule = configureField?.find(rule => rule.field === property);
    if (!fieldRule) return {};
  
    const isRequired = fieldRule.validation === 'M';
    const isDisabled = fieldRule.validation === 'NM';
    const isHidden = fieldRule.validation === 'NA';

  
    return {
      className: `${isRequired ? 'required' : ''} form-label`,
      required: isRequired,
      disabled: isDisabled,
      hidden: isHidden,
    };
  };

  // Below code was commented as it is duplicate and causing re-renders
  // const isIpOrObsSpecialityChart = clientData?.Specialty
  //   ? clientData.Specialty.toLowerCase() === "inpatient" ||
  //     clientData.Specialty.toLowerCase() === "observation"
  //   : false;

  // if (isIpOrObsSpecialityChart) {
  //   setFlagToAllowUserToSelectPriority(true);
  // }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (configureField && configureField.length > 0) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000); 

      return () => clearTimeout(timer); // Cleanup timer on component unmount or re-run
    }
  }, [configureField]);

  const handleChartNoBlur = async (e) => {
    if (e.target.value) {
      const response = await doesChartNoExistInSystem(id, e.target.value, {
        ClientId: data?.ClientId, 
        LocationId: data?.LocationId, 
        ProcessId: data?.ProcessId,
        DOS: data?.inpval?.date_of_service,
      });
      setChartNumberExists(response?.doesExist);
    }
  };
  
  const handleChartNoChange = (e) => {
    getdata(e);
    setChartNumberExists(false);
  };

  return (
    <>
    
    <div className="card card-flush mb-6 mb-xl-9">
    <div className="card-header mt-6 minimize">
      <div className="card-title flex-column">
        <h2 className="mb-1">Chart Info</h2>
        <div className="fs-6 fw-semibold text-muted">
          All relevant chart fields
        </div> 
               
      </div>
      { loading && <div className="text-center mt-6"><span className="spinner-border h-20px w-20px align-middle text-gray-400 text-center" /></div>}

      <div className="card-toolbar mt-0">
        <button className="btn btn-icon btn-sm btn-light-primary justify-content-center">
          <i className="fas fa-minus" />
        </button>
      </div>
    </div>
    {configureField && 
    <div className="card-body p-0">
      <div className="card-body d-flex flex-column pb-0">
        <div className="d-flex flex-column gap-5 gap-md-7">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("chart_no")?.hidden}>
              <label className={isPropertyRequired("chart_no")?.className}></label>
              <input
                type="hidden"
                className="form-control"
                name="id"
                onChange={getdata}
                readOnly
                disabled={!enabled}
              />
              <label className="required form-label">Chart #</label>
              <input
                className="form-control"
                name="chart_no"
                defaultValue={data?.ChartNo}
                onChange={handleChartNoChange}
                onKeyUp={handleKeypress}
                onBlur={handleChartNoBlur}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("chart_no")?.required && !data?.ChartNo ? false : true))
                }
                autoComplete="off"
              />
              {errorsForChat?.chart_no &&
                (inpval?.chart_no === null ||
                  inpval?.chart_no?.trim() === "" ||
                  (errorsForChat?.chart_no !== "Required" &&
                    !strRegex.test(inpval?.chart_no) && chartNumberExists )) && (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.chart_no}
                  </p>
                )}
              {errorsFromAuditorToChart?.chart_no &&
                (inpval?.chart_no === null ||
                  inpval?.chart_no?.trim() === "" ||
                  (errorsFromAuditorToChart?.chart_no !== "Required" &&
                    !strRegex.test(inpval?.chart_no) && chartNumberExists )) && (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.chart_no}
                  </p>
                )}
              {chartNumberExists && (inpval?.chart_no?.trim() !== "") && (
                  <p className="help is-danger errorDanger">
                    {"Chart number already exists"}
                  </p>
                )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("mr_no")?.hidden}>
              <label className={isPropertyRequired("mr_no")?.className}>MR#</label>
              <input
                className="form-control"
                autoComplete="off"
                name="mr_no"
                defaultValue={
                  data?.MR_No !== "" &&
                  data?.MR_No !== 0 &&
                  data?.MR_No !== undefined &&
                  data?.MR_No !== null
                    ? crypto.AES.decrypt(
                        data?.MR_No,
                        process.env.REACT_APP_SECRET_PASS,
                      ).toString(crypto.enc.Utf8)
                    : ""
                }
                onChange={getmr_no}
                onKeyUp={handleKeypressMR}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("mr_no")?.required && !data?.MR_No ? false : true))
                }
              />
              {errorsForChat?.mr_no &&
                (inpval?.mr_no === null ||
                  crypto.AES.decrypt(
                    inpval?.mr_no,
                    process.env.REACT_APP_SECRET_PASS,
                  )
                    .toString(crypto.enc.Utf8)
                    .trim() === "" ||
                  (errorsForChat?.mr_no !== "Required" &&
                    !/^[A-Z]*\d+$/.test(
                      crypto.AES.decrypt(
                        inpval?.mr_no,
                        process.env.REACT_APP_SECRET_PASS,
                      ).toString(crypto.enc.Utf8),
                    ))) && (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.mr_no}
                  </p>
                )}
              {errorsFromAuditorToChart?.mr_no &&
                (inpval?.mr_no === null ||
                  crypto.AES.decrypt(
                    inpval?.mr_no,
                    process.env.REACT_APP_SECRET_PASS,
                  )
                    .toString(crypto.enc.Utf8)
                    .trim() === "" ||
                  (errorsFromAuditorToChart?.mr_no !== "Required" &&
                    !/^[A-Z]*\d+$/.test(
                      crypto.AES.decrypt(
                        inpval?.mr_no,
                        process.env.REACT_APP_SECRET_PASS,
                      ).toString(crypto.enc.Utf8),
                    ))) && (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.mr_no}
                  </p>
                )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("date_of_service")?.hidden}>
              <label className={isPropertyRequired("date_of_service")?.className}>
                Date of Service
              </label>
              <Flatpickr
                className="form-control"
                options={{
                  dateFormat: "m/d/Y",
                  minDate: earliestDOS,
                  maxDate: latestDOS,
                }}
                value={data?.DateOfService}
                name="date_of_service"
                onChange={handleDateTimeChange}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("date_of_service")?.required && !data?.DateOfService ? false : true))
                }
              />
              {errorsForChat?.date_of_service &&
                inpval?.date_of_service === null && (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.date_of_service}
                  </p>
                )}
              {errorsFromAuditorToChart?.date_of_service &&
                inpval?.date_of_service === null && (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.date_of_service}
                  </p>
                )}
            </div>
          </div>
          <div className="row" >
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("admit_date")?.hidden}>
              <label  className={isPropertyRequired("admit_date")?.className}>
                Admit date
              </label>
              <Flatpickr
                className="form-control"
                options={{
                  dateFormat: "m/d/Y",
                  maxDate: latestDOS,
                }}
                value={data?.AdmitDate}
                name="admit_date"
                onChange={handleDateTimeChange}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("admit_date")?.required && !data?.AdmitDate ? false : true))
                }
              />
              {errorsForChat?.admit_date && inpval?.admit_date === null && (
                <p className="help is-danger errorDanger">
                  {errorsForChat?.admit_date}
                </p>
              )}
              {errorsFromAuditorToChart?.admit_date &&
                inpval?.admit_date === null && (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.admit_date}
                  </p>
                )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("discharge_date")?.hidden}>
              <label className={isPropertyRequired("discharge_date")?.className}>
                Discharge date
              </label>
              <Flatpickr
                className="form-control"
                options={{
                  dateFormat: "m/d/Y",
                  minDate: data.DateOfService,
                  maxDate: new Date(),
                }}
                value={data?.DischargeDate}
                name="discharge_date"
                onChange={handleDateTimeChange}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("discharge_date")?.required && !data?.DischargeDate ? false : true))
                }
              />
              {errorsForChat?.discharge_date &&
                inpval?.discharge_date === null && (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.discharge_date}
                  </p>
                )}
              {errorsFromAuditorToChart?.discharge_date &&
                inpval?.discharge_date === null && (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.discharge_date}
                  </p>
                )}
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("disposition")?.hidden}>
              <label className={isPropertyRequired("disposition")?.className}>Disposition</label>
              <Select
                id="disposition"
                name="DispositionId"
                options={renderDispositionList()}
                isMulti={false}
                defaultValue={{
                  label: data.Disposition,
                  value: data.DispositionId,
                }}
                isDisabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("disposition")?.required && !data?.DispositionId ? false : true))
                }
                onChange={handleDispositionChange}
              >
                {data.get?.map((option) => (
                  <option key={option?.id} value={option?.id}>
                    {option?.name}
                  </option>
                ))}
              </Select>
              {errorsForChat?.DispositionId && (
                <p className="help is-danger errorDanger">
                  {errorsForChat?.DispositionId}
                </p>
              )}
              {errorsFromAuditorToChart?.DispositionId && (
                <p className="help is-danger errorDanger">
                  {errorsFromAuditorToChart?.DispositionId}
                </p>
              )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("em")?.hidden}>
              <label className={isPropertyRequired("em")?.className}>EM</label>
              <input
                className="form-control"
                autoComplete="off"
                name="em"
                onChange={getdata}
                defaultValue={data?.Em}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID || (data?.MilestoneId ===
                    milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID &&
                    role !== userRole.Auditor)
                    ? !enabled
                    : (enabled && isPropertyRequired("em")?.required && !data?.Em ? false : true))
                }
              />
              {errorsForChat?.em &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.em}
                  </p>
                )}
              {errorsFromAuditorToChart?.em &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.em}
                  </p>
                )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("primary_diagnosis")?.hidden}>
              <label
                className={isPropertyRequired("primary_diagnosis")?.className}
              >
                Primary diagnosis
              </label>
              <input
                className="form-control"
                autoComplete="off"
                defaultValue={data?.PrimaryDiagnosis}
                onChange={getdata}
                onKeyUp={handleKeypress}
                name="primary_diagnosis"
                required={ isPropertyRequired("primary_diagnosis")?.required}
                disabled={
                  btnDisable || (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ? !enabled : 
                    (enabled && isPropertyRequired("primary_diagnosis")?.required && !data?.PrimaryDiagnosis ? false : true)
                  )
                }
              />
              {errorsForChat?.primary_diagnosis &&
                (inpval?.primary_diagnosis === null ||
                  inpval?.primary_diagnosis?.trim() === "" ||
                  !strRegexPirmaryDiagnosis.test(
                    inpval?.primary_diagnosis,
                  )) && (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.primary_diagnosis}
                  </p>
                )}
              {((errorsFromAuditorToChart?.primary_diagnosis &&
                (inpval?.primary_diagnosis === null ||
                  inpval?.primary_diagnosis?.trim() === "")) ||
                !strRegexPirmaryDiagnosis.test(
                  inpval?.primary_diagnosis,
                )) && (
                <p className="help is-danger errorDanger">
                  {errorsFromAuditorToChart?.primary_diagnosis}
                </p>
              )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6 mt-6">
              <label className=" form-label"></label>
              <input
                type="hidden"
                className="form-control"
                name="ChartMetumId"
                onChange={getdata}
                readOnly
                disabled={!enabled}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("primary_health")?.hidden}>
              <label className={isPropertyRequired("primary_health")?.className}>Primary Health Plan</label>
              <Select
                id="primaryHealth"
                name="PrimaryHealthId"
                options={renderPrimaryHealth()}
                isMulti={false}
                defaultValue={{
                  label: data.PrimaryHealth,
                  value: data.PrimaryHealthId,
                }}
                isDisabled={
                  btnDisable || (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("primary_health")?.required && !data?.PrimaryHealthId ? false : true))
                }
                onChange={handlePrimaryHealthChange}
              />
               {errorsForChat?.primary_health && (
                <p className="help is-danger errorDanger">
                  {errorsForChat?.primary_health}
                </p>
              )}
              {errorsFromAuditorToChart?.primary_health && (
                <p className="help is-danger errorDanger">
                  {errorsFromAuditorToChart?.primary_health}
                </p>
              )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("facility")?.hidden}>
              <label className={isPropertyRequired("facility")?.className}>Facility</label>
              <Select
                id="facility"
                name="FacilityId"
                options={renderFacility()}
                isMulti={false}
                defaultValue={{
                  label: data.Facility,
                  value: data.FacilityId,
                }}
                isDisabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("facility")?.required && !data?.FacilityId ? false : true))
                }
                onChange={handleFacilityChange}
              />
               {errorsForChat?.facility && (
                <p className="help is-danger errorDanger">
                  {errorsForChat?.facility}
                </p>
              )}
              {errorsFromAuditorToChart?.facility && (
                <p className="help is-danger errorDanger">
                  {errorsFromAuditorToChart?.facility}
                </p>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("poa")?.hidden}>
              <label className={isPropertyRequired("poa")?.className}>POA</label>
              <input
                className="form-control"
                autoComplete="off"
                name="poa"
                maxLength={1}
                onChange={getdata}
                defaultValue={data?.poa}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("poa")?.required && !data?.poa ? false : true))
                }
              />
              {errorsForChat?.poa &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.poa}
                  </p>
                )}
                {errorsFromAuditorToChart?.poa &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.poa}
                  </p>
                )}
            </div>

            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("los")?.hidden}>
              <label className={isPropertyRequired("los")?.className}>LOS</label>
              <input
                className="form-control"
                autoComplete="off"
                name="los"
                maxLength={3}
                onChange={getdata}
                defaultValue={data?.los}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                  (data?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID &&
                    role !== userRole.Auditor)
                    ? !enabled
                    : (enabled && isPropertyRequired("los")?.required && !data?.los ? false : true))
                }
              />
              {errorsForChat?.los &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.los}
                  </p>
                )}
                {errorsFromAuditorToChart?.los &&
                (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.los}
                  </p>
                )}
            </div>
            <div className="col-xl-4 col-lg-4 col-6" hidden={isPropertyRequired("drg")?.hidden}>
              <label className={isPropertyRequired("drg")?.className}>DRG Value</label>
              <input
                className="form-control"
                autoComplete="off"
                defaultValue={data?.drg_value}
                onChange={getdata}
                onKeyUp={handleKeypress}
                maxLength={3}
                name="drg_value"
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                    ? !enabled
                    : (enabled && isPropertyRequired("drg")?.required && !data?.drg_value ? false : true))
                }
              />
              {errorsForChat?.drg_value &&
                (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.drg_value}
                  </p>
                )}
                {errorsFromAuditorToChart?.drg_value &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.drg_value}
                  </p>
                )}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-4" hidden={isPropertyRequired("procedure_code")?.hidden}>
              <label className={isPropertyRequired("procedure_code")?.className}>Procedure code</label>
              <input
                className="form-control"
                autoComplete="off"
                name="procedure_code"
                onChange={getdata}
                defaultValue={data?.procedure_code}
                disabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                  (data?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID &&
                    role !== userRole.Auditor)
                    ? !enabled
                    : (enabled && isPropertyRequired("procedure_code")?.required && !data?.procedure_code ? false : true))
                }
              />
              { errorsForChat?.procedure_code &&
                !strRegexForEmModifierProcCode.test(inpval?.procedure_code) &&
                inpval?.procedure_code === "" && (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.procedure_code}
                  </p>
                )}
                {errorsFromAuditorToChart?.procedure_code &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.procedure_code}
                  </p>
                )}
            </div>

            <div className="col-xl-4 col-lg-4 col-4" hidden={isPropertyRequired("sub_specialty")?.hidden}>
              <label className={isPropertyRequired("sub_specialty")?.className}>Sub Specialty</label>
              <Select
                options={renderSubSpecialties()}
                defaultValue={{
                  label: data.SubSpecialty,
                  value: data.SubSpecialtyId,
                }}
                onChange={handleSubSpecialtyChange}
                name="SubSpecialtyId"
                isDisabled={
                  btnDisable ||
                  (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID 
                  ? !enabled 
                  : (enabled && isPropertyRequired("sub_specialty")?.required && !data?.SubSpecialtyId ? false : true))
                }
              ></Select>
               {errorsForChat?.sub_specialty &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsForChat?.sub_specialty}
                  </p>
                )}
              {errorsFromAuditorToChart?.sub_specialty &&
                 (
                  <p className="help is-danger errorDanger">
                    {errorsFromAuditorToChart?.sub_specialty}
                  </p>
                )}
            </div>
          </div>
          <div className="row">
          {chartInfoCustomFields?.filter(item => item?.validation !== "Not-Applicable" && item.placement === "Chart Info").map((field) => <div key={field.id} className="col-xl-4 col-lg-4 col-4 mt-5"
          >
            <label className={`${field?.validation === "Mandatory" ? 'required' : ''} form-label`}
            >{field.name}</label>
            {renderChartInfoCustomField(field)}
            {customFieldsError?.[field.id] && (<p className="help is-danger errorDanger">{ customFieldsError?.[field.id] }</p>)}
          </div>)}
        </div>
        </div>
      </div>
      <div className="separator separator-dashed my-6" />
      <div className="card card-flush mb-6 mb-xl-9">
        <div className="card-header mt-0">
          <div className="card-title flex-column gap-0 gap-md-0 mt-0 mb-6">
            <h2 className="mb-1">Processing Info</h2>
            <div className="fs-6 fw-semibold text-muted">
              All fields related to processing this chart
            </div>
          </div>
        </div>
        <div className="card-body d-flex flex-column pt-0">
          <div className="d-flex flex-column gap-5 gap-md-7">
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-6 mb-4" hidden={isPropertyRequired("chart_status")?.hidden}>
                <label className={isPropertyRequired("chart_status")?.className}>Chart status</label>
                <Select
                  options={renderChartStatusList()}
                  defaultValue={{
                    label: data.Status,
                    value: data.StatusId,
                  }}
                  onChange={handleChartChange}
                  name="chart_status"
                  isDisabled={
                    btnDisable ||
                    (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                      data?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                      ? !enabled
                      : (enabled && isPropertyRequired("chart_status")?.required && !data?.StatusId ? false : true))
                  }
                >
                  {chartstatus?.map((option) => (
                    <option key={option?.id} value={option?.id}>
                      {option?.name}
                    </option>
                  ))}
                </Select>
                {errorsForChat?.chart_status &&
                  defaultChartStatus?.value === 1 && (
                    <p className="help is-danger errorDanger">
                      {errorsForChat?.chart_status}
                    </p>
                  )}
                {errorsFromAuditorToChart?.chart_status &&
                  defaultChartStatus?.value === 1 && (
                    <p className="help is-danger errorDanger">
                      {errorsFromAuditorToChart?.chart_status}
                    </p>
                  )}
              </div>
              <div className="col-xl-9 col-lg-9 col-12 mb-4" hidden={isPropertyRequired("responsible_parties")?.hidden}>
                <label
                  className={isPropertyRequired("responsible_parties")?.className}
                >
                  Responsible party
                </label>
                {
                  <Select
                    name="ResponsibleParties"
                    options={renderResponsibleList()}
                    isSearchable={false}
                    defaultValue={data.ResponsibleParties}
                    isMulti={true}
                    onChange={handleRespChange}
                    isDisabled={
                      btnDisable ||
                      (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                        data?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                        ? !enabled
                        : (enabled && isPropertyRequired("responsible_parties")?.required && !data?.ResponsibleParties ? false : true))
                    }
                  />
                }
                {errorsForChat?.ResponsibleParties &&
                  (defaultResponsible === undefined ||
                    defaultResponsible?.length === 0) && (
                    <p className="help is-danger errorDanger">
                      {errorsForChat?.ResponsibleParties}
                    </p>
                  )}
                {errorsFromAuditorToChart?.ResponsibleParties &&
                  (defaultResponsible === undefined ||
                    defaultResponsible?.length === 0) && (
                    <p className="help is-danger errorDanger">
                      {errorsFromAuditorToChart?.ResponsibleParties}
                    </p>
                  )}
              </div>
              <div className="col-12 mt-6 mb-4">
                <label
                  className={
                    defaultChartStatus?.value ===
                    chartStatusConstants.INCOMPLETE_STATUS_ID
                      ? "required form-label"
                      : ""
                  }
                >
                  Hold reason
                </label>
                {defaultChartStatus?.value ===
                  chartStatusConstants.INCOMPLETE_STATUS_ID ||
                statusId === chartStatusConstants.INCOMPLETE_STATUS_ID ? (
                  <Select
                    name="HoldReasons"
                    isSearchable={false}
                    options={
                      noReasons
                        ? { label: "", value: "" }
                        : renderHoldList()
                    }
                    isMulti={true}
                    isDisabled={
                      btnDisable ||
                      (data?.MilestoneId ===
                        milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                      data?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                        ? !enabled
                        : true)
                    }
                    defaultValue={data.HoldReasons}
                    onChange={handleHoldChange}
                  ></Select>
                ) : (
                  <Select
                    defaultValue={data.HoldReasons}
                    isDisabled={true}
                    onChange={handleHoldChange}
                  ></Select>
                )}
                {errorsForChat?.HoldReasons &&
                  (defaultHold === undefined ||
                    defaultHold?.length === 0) &&
                  defaultChartStatus?.value ===
                    chartStatusConstants.INCOMPLETE_STATUS_ID && (
                    <p className="help is-danger errorDanger">
                      {errorsForChat?.HoldReasons}
                    </p>
                  )}
                {errorsFromAuditorToChart?.HoldReasons &&
                  (defaultHold === undefined ||
                    defaultHold?.length === 0) &&
                  defaultChartStatus?.value ===
                    chartStatusConstants.INCOMPLETE_STATUS_ID && (
                    <p className="help is-danger errorDanger">
                      {errorsFromAuditorToChart?.HoldReasons}
                    </p>
                  )}
              </div>
            </div>
            <div className="row fv-row">
              <div className="col-12 mb-4">
                <div className="row">
                  <div className="col-12" hidden={isPropertyRequired("coder_comments")?.hidden}>
                    <label className={isPropertyRequired("coder_comments")?.className}>
                      Coder comments to client
                    </label>
                    {
                      <TextareaAutosize
                        autoComplete="off"
                        className="form-control"
                        name="coder_comments"
                        defaultValue={data?.CoderComments}
                        aria-label="With textarea"
                        onChange={getdata}
                        onKeyUp={handleKeypress}
                        disabled={
                          data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID &&
                          (defaultChartStatus?.value !== chartStatusConstants.COMPLETE_STATUS_ID ||
                            statusId !== chartStatusConstants.COMPLETE_STATUS_ID)
                            ? !enabled
                            : (enabled && isPropertyRequired("coder_comments")?.required && !data?.CoderComments?.length ? false : true)
                        }
                        minRows={3}
                        maxRows={12}
                      />
                    }
                    {errorsForChat?.coder_comments &&
                        (
                        <p className="help is-danger errorDanger">
                          {errorsForChat?.coder_comments}
                        </p>
                      )}
                    {errorsFromAuditorToChart?.coder_comments &&
                       (
                        <p className="help is-danger errorDanger">
                          {errorsFromAuditorToChart?.coder_comments}
                        </p>
                      )}
                  </div>
                  <div className="col-12" hidden={isPropertyRequired("rejection_comments")?.hidden}>
                    <label className={isPropertyRequired("rejection_comments")?.className}>
                      Rejection / Denial Comments
                    </label>
                    {
                      <TextareaAutosize
                        autoComplete="off"
                        className="form-control"
                        name="denial_comments"
                        defaultValue={data?.DenialComments}
                        aria-label="With textarea"
                        onChange={getdata}
                        onKeyUp={handleKeypress}
                        disabled={
                          (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                            data?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID)
                            ? !enabled
                            : (enabled && isPropertyRequired("rejection_comments")?.required && !data?.DenialComments?.length ? false : true)
                        }
                        minRows={3}
                        maxRows={12}
                      />
                    }
                    {errorsForChat?.denial_comments &&
                       (
                        <p className="help is-danger errorDanger">
                          {errorsForChat?.denial_comments}
                        </p>
                      )}
                    {errorsFromAuditorToChart?.denial_comments &&
                       (
                        <p className="help is-danger errorDanger">
                          {errorsFromAuditorToChart?.denial_comments}
                        </p>
                      )}
                  </div>
                  <div className="col-12" hidden={isPropertyRequired("deficiency_comments")?.hidden}>
                    <label className={isPropertyRequired("deficiency_comments")?.className}>
                      Deficiency Comments
                    </label>
                    {
                      <TextareaAutosize
                        autoComplete="off"
                        className="form-control"
                        name="deficiency_comments"
                        defaultValue={data?.DeficiencyComments}
                        aria-label="With textarea"
                        onChange={getdata}
                        onKeyUp={handleKeypress}
                        disabled={
                          (data?.MilestoneId === milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                            data?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID)
                            ? !enabled
                            : (enabled && isPropertyRequired("deficiency_comments")?.required && !data?.DeficiencyComments?.length ? false : true)
                        }
                        minRows={3}
                        maxRows={12}
                      />
                    }
                     {errorsForChat?.deficiency_comments &&
                       (
                        <p className="help is-danger errorDanger">
                          {errorsForChat?.deficiency_comments}
                        </p>
                      )}
                    {errorsFromAuditorToChart?.deficiency_comments &&
                       (
                        <p className="help is-danger errorDanger">
                          {errorsFromAuditorToChart?.deficiency_comments}
                        </p>
                      )}
                  </div>
                  <div className="col-xl-3 col-lg-3 col-6 mt-5">
                    <label className=" form-label">
                      Date of completion
                    </label>
                    {
                      <Flatpickr
                        className="form-control"
                        value={
                          inpval.date_of_completion ??
                          data?.DateOfCompletion
                        }
                        options={dosOP}
                        name="date_of_completion"
                        onChange={handleDateTimeChange}
                        disabled={true}
                      />
                    }
                    {errorsForChat?.date_of_completion && (
                      <p className="help is-danger errorDanger">
                        {errorsForChat?.date_of_completion}
                      </p>
                    )}
                  </div>

                  <div className="col-md-4 col-4 mt-5">
                    <label className="required form-label">
                      Audit options
                    </label>
                    <Select
                      name="AuditOptionId"
                      isSearchable={false}
                      options={
                        none || noneDefault
                          ? [{ label: "", value: "" }]
                          : renderList()
                      }
                      isMulti={true}
                      defaultValue={data.AuditOptions}
                      value={none ? noneForDisplay : defaultAudit}
                      isDisabled={
                        btnDisable ||
                        (data?.MilestoneId ===
                          milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                        data?.MilestoneId ===
                          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      onChange={handleAuditChange}
                    ></Select>
                    {errorsForChat?.AuditOptionsId &&
                      (defaultAudit === undefined ||
                        defaultAudit?.length === 0) && (
                        <p className="help is-danger errorDanger">
                          {errorsForChat?.AuditOptionsId}
                        </p>
                      )}
                    {errorsFromAuditorToChart?.AuditOptionsId &&
                      (defaultAudit === undefined ||
                        defaultAudit?.length === 0) && (
                        <p className="help is-danger errorDanger">
                          {errorsFromAuditorToChart?.AuditOptionsId}
                        </p>
                      )}
                  </div>
                  <div className="col-md-4 col-4 mt-5">
                    <label className="required form-label">
                      Coder QC Status
                    </label>
                    <Select
                      options={renderQC()}
                      value={qcValue}
                      onChange={handledefaultQC}
                      name="QC_status"
                      isDisabled={
                        isQc !== null &&
                        isQc !== undefined &&
                        isQc !== 1 &&
                        data?.MilestoneId ===
                          milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID &&
                        !btnDisable
                          ? !enabled
                          : true
                      }
                    />{" "}
                    {errorsForChat?.QC_status &&
                      (defaultQC?.value === qcStatusConstants.QC_PASS_ID ||
                        defaultQC?.value ===
                          qcStatusConstants.QC_FAIL_ID) && (
                        <p className="help is-danger errorDanger">
                          {errorsForChat?.QC_status ||
                            errorsFromAuditorToChart?.QC_status}
                        </p>
                      )}
                  </div>
                  <div className="row">
                    <div className="col-md-4 col-4 mt-5">
                      <label className="form-label">
                        Allocate to auditor
                      </label>
                      <Select
                        options={renderAllocateAuditor()}
                        defaultValue={
                          clientData.MilestoneId ===
                            milestoneConstants.READY_TO_AUDIT_MILESTONE_ID ||
                          clientData.MilestoneId ===
                            milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID ||
                          clientData.MilestoneId ===
                            milestoneConstants.AUDIT_DONE_MILESTONE_ID ||
                          (auth.role !== "Coder" &&
                            auth.role !== "Team Lead" &&
                            auth.role !== "Manager" &&
                            clientData.MilestoneId ===
                              milestoneConstants.READY_TO_CODE_MILESTONE_ID)
                            ? {
                                label:
                                  data?.UserFirstName +
                                  " " +
                                  data?.UserLastName,
                                value: data?.UserId,
                              }
                            : clientData.MilestoneId ===
                              milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                            ? {
                                label: "",
                                value: "",
                              }
                            : {
                                label: data?.next_user?.name ?? "",
                                value: data?.next_user?.id ?? "",
                              }
                        }
                        onChange={handleAllocateAuditor}
                        name="UserId"
                        isDisabled={
                          btnDisable ||
                          allocateEDCoder ||
                          !enabled ||
                          data?.MilestoneId !==
                            milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                        }
                      ></Select>
                      {errorsForChat?.UserId && !allocateAuditor && (
                        <p className="help is-danger errorDanger">
                          {errorsForChat?.UserId}
                        </p>
                      )}
                      {errorsFromAuditorToChart?.UserId && (
                        <p className="help is-danger errorDanger">
                          {errorsFromAuditorToChart?.UserId}
                        </p>
                      )}
                    </div>
                    <div className="col-md-4 col-4 mt-5">
                      <label className="form-label">
                        Allocate to Coder
                      </label>
                      <Select
                        options={renderActiveCoder()}
                        onChange={handleAllocatEDCoder}
                        name="EDCoderId"
                        value={allocateEDCoder}
                        isDisabled={
                          btnDisable ||
                          !enabled ||
                          data?.MilestoneId !==
                            milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID
                        }
                      ></Select>
                    </div>
                    <div className="col-md-4 col-4 mt-5">
                      <label className="form-label">Priority</label>
                      <Select
                        options={renderPriorityList()}
                        onChange={handlePriorityChange}
                        name="PriorityId"
                        value={priority}
                        isDisabled={
                          btnDisable ||
                          !enabled ||
                          data?.MilestoneId !==
                                milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                                !isUserAllowedToSelectPriority
                              }
                            ></Select>
                          </div>
                          {chartInfoCustomFields?.filter(item => item?.validation !== "Not-Applicable" && item.placement === "Processing Info").map((field) => <div key={field.id} className="col-xl-4 col-lg-4 col-4 mt-5"
                          >
                            <label className={`${field?.validation === "Mandatory" ? 'required' : ''} form-label`}
                            >{field.name}</label>
                            {renderChartInfoCustomField(field)}
                            {customFieldsError?.[field.id] && (<p className="help is-danger errorDanger">{customFieldsError?.[field.id]}</p>)}
                          </div>)}
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
    
      
      {showConfirmationModal && (
        <AllocationConfirmationModal
          coderAllocationEvent={coderAllocationEvent}
          setAllocateEDCoder={setAllocateEDCoder}
          showConfirmationModal={showConfirmationModal}
          setShowConfirmationModal={setShowConfirmationModal}
        />
      )}
    </>
  );
}
export default ChartInfo;
